"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineGettextProperty = void 0;
const RE_PATTERN_GETTEXT = /^_\(\"([\w\d \.\,\_\-%$\/\(\)']+)\"\)$/, RE_PATTERN_PGETTEXT = /^P_\(\"([\w\d \.\,\_\-%$\/\(\)]+)\" *, *\"([\w\d \.\,\_\-%$\/\(\)']+)\"\)$/, RE_PATTERN_NGETTEXT = /^N_\(\"([\w\d \.\,\_\-%$\/\(\)']+)\" *, *\"([\w\d \.\,\_\-%$\/\(\)']+)\" *, *([\w\d\[\]\.\_%$\/]+)\)$/;
function defineGettextProperty(target, field, expression, translator) {
    let match;
    const options = { msgid: '' };
    while ((match = RE_PATTERN_GETTEXT.exec(expression)) !== null) {
        options.msgid = match[1];
        break;
    }
    if (!options.msgid) {
        while ((match = RE_PATTERN_PGETTEXT.exec(expression)) !== null) {
            options.context = match[1];
            options.msgid = match[2];
            break;
        }
    }
    if (!options.msgid) {
        while ((match = RE_PATTERN_NGETTEXT.exec(expression)) !== null) {
            options.msgid = match[1];
            options.plural = match[2];
            break;
        }
    }
    if (!options.msgid) {
        return;
    }
    Object.defineProperty(target, field, {
        get: function () {
            return translator.translate(options);
        },
    });
}
exports.defineGettextProperty = defineGettextProperty;
//# sourceMappingURL=property.js.map